<script setup>
import { ref } from 'vue'
import { FormBuilder, useSchema } from '@codinglabsau/inertia-form-builder'
import {
  Button,
  Dialog,
  DialogTrigger,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Textarea,
} from '@codinglabsau/gooey'
import SubscriptionPrice from '@/Components/SubscriptionPrice.vue'
import { LoaderCircleIcon } from 'lucide-vue-next'

const props = defineProps({
  recipient: Object,
  variant: {
    type: String,
    default: null,
  },
  triggerClass: {
    type: String,
    default: '',
  },
})

const open = ref(false)

const schema = useSchema({
  message: {
    component: Textarea,
  },
})

const closeModal = () => {
  open.value = false
  schema.form.reset()
}

const submit = () => {
  schema.form
    .transform((data) => ({
      ...data,
      recipient_id: props.recipient.id,
    }))
    .post(route('messages.store'), {
      preserveScroll: true,
    })
}
</script>

<template>
  <Dialog :open="open">
    <DialogTrigger as-child>
      <Button v-if="!variant" :class="triggerClass" @click="open = true">
        <slot />
      </Button>

      <Button v-else :variant="variant" :class="triggerClass" @click="open = true">
        <slot />
      </Button>
    </DialogTrigger>

    <DialogContent @close="closeModal" @interact-outside="closeModal">
      <DialogHeader>
        <DialogTitle>Message {{ recipient.name }}</DialogTitle>
        <DialogClose />
      </DialogHeader>

      <div v-if="$page.props.auth.user?.supporter">
        <form @submit.prevent="submit">
          <FormBuilder :schema="schema" class="mt-0">
            <template #actions>
              <div class="flex gap-2">
                <Button variant="outline" @click="closeModal()">Cancel</Button>
                <Button type="submit">
                  Send
                  <LoaderCircleIcon
                    v-show="schema.form.processing"
                    class="ml-2 size-4 animate-spin"
                  />
                </Button>
              </div>
            </template>
          </FormBuilder>
        </form>
      </div>
      <template v-else>
        <DialogDescription class="mb-4 flex w-full justify-center text-gray-600">
          You will need to subscribe as a supporter to start new conversations.
        </DialogDescription>
        <SubscriptionPrice />
      </template>
    </DialogContent>
  </Dialog>
</template>
